import { HTTP } from '../../axios/axios'

async function getAll (lang) {
  try {
    const res = await HTTP.get('/parallax', { headers: { 'accept-language': lang } })
    return res.data
  } catch (error) {
    console.log(error)
  }
}
async function addOne (parallax, lang) {
  parallax.lang = lang
  return await HTTP.post('/parallax', parallax)
}
async function update (parallax, id) {
  return await HTTP.patch('/parallax/' + id, parallax)
}
async function deleteOne (parallax) {
  return await HTTP.delete('/parallax/' + parallax._id)
}

async function deleteMany (arr) {
  return await HTTP.post('/parallax/many', { _id: arr })
}

export default { getAll, deleteMany, addOne, update, deleteOne }
